import React from "react";
import { MuiBox, MuiTypography } from "components/atoms";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import "dayjs/locale/hi";
import "dayjs/locale/gu";

const InformationModal = ({ title, item }) => {
  const { t, i18n } = useTranslation();
  const showSharedBy = item?.shared_by && item.shared_by !== item.owner;
  // const isShared = Boolean(item?.isShared);
  // const location = useLocation();
  // const pathname = location.pathname;

  // const isFolderPage = pathname.includes("/drive/folder/");

  const getFolderLocation = (folderDetails) => {
    const path = folderDetails?.location || folderDetails?.name;

    const pageName =
      folderDetails?.isShared?.email || folderDetails?.isParentOwner?.email
        ? t("common.sharedWithMe")
        : t(t("common.myDrive"));

    return `${pageName}/${path}`;
  };

  // ---------- Proper size formatting ----------
  const formatFileSize = (bytes) => {
    const size = Number(bytes);

    if (!size || isNaN(size) || size <= 0) {
      return "0 Bytes";
    }

    const KB = 1024;
    const MB = KB * 1024;
    const GB = MB * 1024;

    if (size >= GB) {
      return `${(size / GB).toFixed(2)} GB`;
    }
    if (size >= MB) {
      return `${(size / MB).toFixed(2)} MB`;
    }
    if (size >= KB) {
      return `${(size / KB).toFixed(2)} KB`;
    }
    return `${size} Bytes`;
  };

  return (
    <MuiBox
      sx={{ display: "flex", flexDirection: "column", gap: "16px", p: "24px" }}
    >
      <MuiTypography fontWeight="600" variant="20" color="text.darkBlack">
        {title}
      </MuiTypography>

      {item?.type !== "folder" && (
        <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
          <MuiTypography fontWeight="400" variant="16" color="text.darkBlack">
            {t("common.type")}
          </MuiTypography>
          <MuiTypography fontWeight="400" variant="14" color="text.gray900">
            {item?.fileType?.replace(/^\./, "")}
          </MuiTypography>
        </MuiBox>
      )}

      <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
        <MuiTypography fontWeight="400" variant="16" color="text.darkBlack">
          {t("modal.info.size")}
        </MuiTypography>
        <MuiTypography fontWeight="400" variant="14" color="text.gray900">
          {formatFileSize(item?.size)}
        </MuiTypography>
      </MuiBox>

      <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
        <MuiTypography fontWeight="400" variant="16" color="text.darkBlack">
          {t("modal.filter.owner")}
        </MuiTypography>
        <MuiTypography fontWeight="400" variant="14" color="text.gray900">
          {item?.owner ?? item?.isUser?.email}
        </MuiTypography>
      </MuiBox>
      {showSharedBy && (
        <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
          <MuiTypography fontWeight="400" variant="16" color="text.darkBlack">
            {t("modal.info.folderOwner")}
          </MuiTypography>
          <MuiTypography fontWeight="400" variant="14" color="text.gray900">
            {item?.shared_by}
          </MuiTypography>
        </MuiBox>
      )}

      <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
        <MuiTypography fontWeight="400" variant="16" color="text.darkBlack">
          {t("common.location")}
        </MuiTypography>
        <MuiTypography
          fontWeight="400"
          variant="14"
          color="text.gray900"
          sx={{ wordBreak: "break-all" }}
        >
          {/* {isFolderPage &&
            (!isShared
              ? driveData?.folder?.user?.email === profile?.email
                ? "My Drive/"
                : "Shared with me/"
              : "Shared with me/")}

          {item?.location} */}
          {getFolderLocation(item)}
        </MuiTypography>
      </MuiBox>

      <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
        <MuiTypography fontWeight="400" variant="16" color="text.darkBlack">
          {t("modal.info.created")}
        </MuiTypography>
        <MuiTypography fontWeight="400" variant="14" color="text.gray900">
          {dayjs(Number(item?.date))
            .locale(i18n.language)
            .format("MMMM D, YYYY")}
        </MuiTypography>
      </MuiBox>
    </MuiBox>
  );
};

export default InformationModal;
